import { createContext, useContext } from 'react'

const PresetFilterSheetLayoutContext = createContext(false)

export const PresetFilterSheetLayoutProvider = PresetFilterSheetLayoutContext.Provider

export const usePresetFilterSheetLayout = () => useContext(PresetFilterSheetLayoutContext)
